import React from "react";
import ReactDOM from "react-dom/client";
import { store, persistor } from './store/index';
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/App.scss";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { checkStripeErrorAfterReload } from "./helpers/stripeErrorLogger";

// Force HTTPS in production
if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.replace('https://' + window.location.host + window.location.pathname + window.location.search + window.location.hash);
}

checkStripeErrorAfterReload();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>

    </Provider>
  </React.StrictMode>
);

reportWebVitals();
